<template>
  <div id="innerpage">
    <contactPopup v-if="ContentModal" />
    <div id='stars'></div>
    <div id='stars2'></div>
    <div id='stars3'></div>

    <main id="main" data-page-id="home">
      <section class="hero-section hero-section__IVR" style="visibility: inherit; opacity: 1;">
        <div class="container row main__container">
          <div class="js-content-block text-block">
            <h1 class="title md-title" style="opacity: 1; transform: translate3d(0px, 0px, 0px); margin-top:-20px">
              {{getDataSector().title}}
            </h1>
            <p class="subtitle" style="opacity: 1; transform: translate3d(0px, 0px, 0px);color:white">
              {{getDataSector().desc}}
            </p>
            <a @click="openModel" class="button button--transparent-grad pulse " href="#">Inquiry</a>
          </div>


          <!-- has-css-animate -->
          <div class="js-image image-block has-css-animate js-active"
            style="flex:1;opacity: 1; transform: translate3d(0px, 0px, 0px);">
            <div class="image__wrap">
              <div class="ivr-hero-rings__wrap">
                <img src="../../../assets/img/ivr-ring-1.png" alt="ring" class="hero-ring lazy lazyLoaded"
                  load-priority="0">
                <img src="../../../assets/img/ivr-ring-2.png" alt="ring" class="hero-ring lazy lazyLoaded"
                  load-priority="0">
                <img src="../../../assets/img/ivr-ring-3.png" alt="ring" class="hero-ring lazy lazyLoaded"
                  load-priority="0">
                <img src="../../../assets/img/ivr-ring-4.png" alt="ring" class="hero-ring lazy lazyLoaded"
                  data-load-priority="0">
              </div>
              <img data-src="../../../assets/img/ivr-hero-sphere.png" alt="IVR image" class="ivr-sphere lazy lazyLoaded"
                data-load-priority="0" src="../../../assets/img/ivr-hero-sphere.png">
              <div class="ivr-hero-shines__wrap">
                <img src="../../../assets/img/ivr-shine.png" alt="shine" class="lazy lazyLoaded hero-shine"
                  data-load-priority="0" data-load-add-class="hero-shine">
                <img src="../../../assets/img/ivr-shine.png" alt="shine" class="lazy lazyLoaded hero-shine"
                  data-load-priority="0" data-load-add-class="hero-shine">
              </div>
              <!-- <span class="video-placeholder" hidden></span> -->
              <img src="../../../assets/img/ivr-video-placeholder.png" alt="" class="video-placeholder" hidden="">
              <video loop="" muted="" playsinline="" class="video-js ivr__hero__video has-mix-blend lazy lazyLoaded"
                data-load-priority="0">
                <source type="video/webm; codecs=&quot;vp8, vorbis&quot;" src="/assets/video/hero-video__ivr.webm"
                  data-src="/assets/video/hero-video__ivr.webm">
                <source type="video/mp4; codecs=&quot;avc1.42E01E, mp4a.40.2&quot;"
                  src="/assets/video/hero-video__ivr.mp4" data-src="/assets/video/hero-video__ivr.mp4">
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
   

      </section>
      <div class=" container mt-10 ">
              <div class="Services_title">
                Services
              </div>
              <div class="Sectors_services">
                <div class="Sectors_services__item" v-for="item in getDataSector().services">

                  <h2>{{ getServiceById(item).title }}</h2>
                  <p v-html="getServiceById(item).desc">

                  </p>
                </div>
              </div>
      </div>

      <section class="started-section">
        <video class="bg_innerpages" autoplay muted loop src="../../../assets/video/services.mp4"></video>

        <div class="container row started__container">

          <div class="content__left">
            <div class="js-content-block text-block">
              <h2 class="title md-title">MI</h2>
              <p class="subtitle">this is where imagination meets innovation.</p>
            </div>
          </div>
          <div class="content__right">
            <div class="buttons__wrap">
              <router-link class="button button--white-hover-trans pulse" to="/contact">Contact</router-link>

              <a href="https://web.mobilityintel.com" class="button button--transparent pulse">get started</a>
            </div>
          </div>
        </div>
      </section>


    </main>
  </div>
</template>

<script>
  import global from '@/mixins/global'
  import dataSectors from '@/assets/data/sectors'
  import dataServices from '@/assets/data/services'
  import contactPopup from './contact';
  import EventBus from '@/event-bus';

  export default {
    name: 'innerpage',
    data() {
      return {
        type: this.$route.params.type,
        dataSector: undefined,
        ContentModal:undefined
      };
    },
    components: {
      contactPopup
    },
    mixins: [global],

    methods: {
      NextSlide() {
        var val = $("section.s2").offset().top;
        console.log("data-scroll =", val);
        window.scrollTo({
          top: val,
          behavior: 'smooth'
        });
      },
      getDataSector() {
        var slug = this.type;
        return dataSectors.data.filter(function (data) {
          return data.slug == slug
        }).shift()
      },
      getServiceById(id) {
        return dataServices.data.filter(function (data) {
          return data.id == id
        }).shift()
      },
      openModel() {
        this.ContentModal = this.getDataSector();
      }
    },
    beforeRouteUpdate(to, from, next) {
      this.type = to.params.type;
      this.getDataSector();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      next();
    },
    mounted() {
      $(document).on('click', '.membership__header', function () {

        $(this).next().toggle();
      })
      if (dataSectors) {
        console.log("dataSectors", this.getDataSector());
      }

      EventBus.$on('close-modal', () => {
        this.ContentModal = undefined;
      });
    },
    metaInfo: {
      title: 'Appraisal - for Governments',
    },
  };

</script>

<style lang="scss">
  @import '../../assets/style/stars';

  a.next_slide {
    cursor: pointer;
    position: absolute;
    bottom: 0;
    transform: translateX(-50%);
    left: 50%;
  }

  section.s2.centerRow {
    min-height: 100vh;
  }


  section.s2.centerRow .grid_items {
    margin-top: auto;
    margin-bottom: auto;
  }

  .flex {
    display: flex;
  }

  a.next_slide svg {
    max-width: 32px;
    cursor: pointer;
  }

  .grid_items {
    text-align: left;
    padding: 77px 33px;
    color: white;
  }

  .grid_items h4 {
    text-transform: uppercase;
    font-size: 25px;
    font-weight: 300;
    padding: 0;
    margin: 0;
    margin-top: 8px;
  }

  a.next_slide {
    z-index: 5;
  }

  .Sectors_services {
    color: white;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-bottom: 49px;
  }

  .Sectors_services__item {
    width: calc(100% / 2);
    padding: 0 27px;
    margin-bottom: 15px;
    @media screen and (max-width:768px) {
      width: 100%;
    }
  }
.mt-10 {
    margin-top: 50px
}

  .Sectors_services__item h2 {
    border-left: 4px solid #24ad60;
    padding-left: 13px;
    min-height: 58px;
    align-items: center;
    align-content: center;
    display: flex;
  }

  .Sectors_services__item p {
    padding-left: 19px;
  }

  .Services_title {
    color: white;
    border-bottom: 2px solid #24ad60;
    width: 100%;
    font-size: 34px;
    font-weight: 100;
    padding: 17px 17px;
    margin-bottom: 20px;
  }

  ul.membership {
    display: none;
    border: 1px solid white;
    margin: 0;
    padding: 30px;
  }

  .membership__header {
    border: 1px solid white;
    padding: 8px;
  }

  .membership__header:after {
    content: "+";
    margin-right: 15px;
    position: absolute;
    right: 0;
    top: 7px;
  }

  .membership__header {
    position: relative;
  }
  .sentsuccesfully {
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sectors/innerpage.vue